
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[usernameOrId]",
      function () {
        return require("private-next-pages/[usernameOrId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[usernameOrId]"])
      });
    }
  